import React, { Fragment } from "react";
import { Table, Label } from "reactstrap";
import { Warning } from "../../Warning/Warning";
import { useSelector } from "react-redux";
import { Container } from "../../UI/Container/Container";
import { Col, Row } from "../../UI/Customstrap/Customstrap";
import { getTexts } from "../../../reducers/selectors";
import style from "./Grid.scss";
import AuthorizationRow from "./AuthorizationRow/AuthorizationRow";

export const Grid = ({ authorizations, onAuthorize, onReject, loading, setLoading }) => {
  const texts = useSelector(getTexts);

  const EmptyAuthorizations = () => {
    return (
      <div className={style.emptyMessage} colSpan={7}>
        No hay autorizaciones.
      </div>
    );
  };

  return (
    <Fragment>
      <Row className={style.headerTitle}>
        <Label>Autorizaciones</Label>
      </Row>
      <div className={style.isMobile}>
        {authorizations.length === 0 ? (
          <EmptyAuthorizations />
        ) : (
          <div className="cards-container">
            {authorizations.map((authorizationItem, idx) => {
              let description = "";
              let ammountString = "";
              let operationValue = "";
              let ammount = 0;
              let currency = "";
              let side = "";

              if (authorizationItem.process === "Order" && authorizationItem.info) {
                const orderInfo = JSON.parse(authorizationItem.info);

                currency = orderInfo.OrderCurrencySymbol;
                if (orderInfo.OrderCurrencySymbol.trim() === "PYG") {
                  currency = "GS";
                }

                side = orderInfo.OrderSide.trim() === "Buy" ? "Compra " : "Venta ";

                if (orderInfo.AssetClassForm.trim() === "Mutual Funds") {
                  if (orderInfo.OrderSide.trim() === "Buy") {
                    side = "Suscripción ";
                  } else {
                    side = orderInfo.CurrentAccount.IsFullLiquidation ? "Rescate Total " : "Rescate Parcial ";
                  }
                }

                if (orderInfo.AssetClassForm.trim() === "Repo") {
                  side = orderInfo.OrderSide.trim() === "Buy" ? "Reportador " : "Reportado ";
                }

                description += `${orderInfo.AssetTicker.trim()} - ${orderInfo.AssetDescription.trim()} `;
                operationValue = orderInfo.CurrentAccount.Precheck.Total;

                switch (orderInfo.OrderType.trim()) {
                  case "Market":
                  case "MarketOnOpen":
                  case "MarketOnClose":
                    ammountString = "Mercado";
                    break;
                  case "Limit":
                    ammountString = "Limit";
                    ammount = orderInfo.OrderPrice;
                    break;
                  case "Stop":
                    ammountString = "Stop";
                    ammount = orderInfo.OrderStopPrice;
                    break;
                  case "StopLimit":
                    ammountString = "Stop Limit";
                    ammount = orderInfo.OrderStopPrice;
                    break;
                  default:
                    break;
                }
                description += `@ ${ammountString}`;
              }
              return (
                <div className={style.cardContainer}>
                  <AuthorizationRow
                    authItem={authorizationItem}
                    side={side}
                    description={description}
                    ammount={ammount}
                    operationValue={operationValue}
                    currency={currency}
                    idx={idx}
                    onAuthorize={onAuthorize}
                    onReject={onReject}
                    loading={loading}
                    setLoading={setLoading}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Row className={style.isWeb}>
        <Col lg="12">
          <Container className={style.container}>
            {authorizations.length === 0 ? (
              <EmptyAuthorizations />
            ) : (
              <Row className={style.authorizationsTableRow}>
                <Table className={style.table}>
                  <thead className={style.tableHead}>
                    <tr className={style.tableRow}>
                      <th className={`${style.tableH} ${style.sm}`}>Fecha</th>
                      <th className={`${style.tableH} ${style.md} ${style.sm}`}>Tipo</th>
                      <th className={style.tableH}>Instrumento</th>
                      <th className={`${style.tableH} ${style.sm}`}>Precio</th>
                      <th className={`${style.tableH} ${style.md} ${style.sm}`} id={style.tablaMonto}>
                        Monto total a operar
                      </th>
                      <th className={`${style.tableH} ${style.md} ${style.sm}`}>Moneda</th>
                      {/* <th className={style.tableH}></th> */}
                      <th className={style.tableH}></th>
                    </tr>
                  </thead>
                  <tbody className={style.tableBody}>
                    {authorizations.map((authorizationItem, idx) => {
                      let description = "";
                      let ammountString = "";
                      let operationValue = "";
                      let ammount = 0;
                      let currency = "";
                      let side = "";

                      if (authorizationItem.process === "Order" && authorizationItem.info) {
                        const orderInfo = JSON.parse(authorizationItem.info);

                        currency = orderInfo.OrderCurrencySymbol;
                        if (orderInfo.OrderCurrencySymbol.trim() === "PYG") {
                          currency = "GS";
                        }

                        side = orderInfo.OrderSide.trim() === "Buy" ? "Compra " : "Venta ";

                        if (orderInfo.AssetClassForm.trim() === "Mutual Funds") {
                          if (orderInfo.OrderSide.trim() === "Buy") {
                            side = "Suscripción ";
                          } else {
                            side = orderInfo.CurrentAccount.IsFullLiquidation
                              ? "Rescate Total "
                              : "Rescate Parcial ";
                          }
                        }

                        if (orderInfo.AssetClassForm.trim() === "Repo") {
                          side = orderInfo.OrderSide.trim() === "Buy" ? "Reportador " : "Reportado ";
                        }

                        description += `${orderInfo.AssetTicker.trim()} - ${orderInfo.AssetDescription.trim()} `;
                        operationValue = orderInfo.CurrentAccount.Precheck.Total;

                        switch (orderInfo.OrderType.trim()) {
                          case "Market":
                          case "MarketOnOpen":
                          case "MarketOnClose":
                            ammountString = "Mercado";
                            break;
                          case "Limit":
                            ammountString = "Limit";
                            ammount = orderInfo.OrderPrice;
                            break;
                          case "Stop":
                            ammountString = "Stop";
                            ammount = orderInfo.OrderStopPrice;
                            break;
                          case "StopLimit":
                            ammountString = "Stop Limit";
                            ammount = orderInfo.OrderStopPrice;
                            break;
                          default:
                            break;
                        }
                        description += `@ ${ammountString}`;
                      }
                      return (
                        <AuthorizationRow
                          authItem={authorizationItem}
                          side={side}
                          description={description}
                          ammount={ammount}
                          operationValue={operationValue}
                          currency={currency}
                          idx={idx}
                          onAuthorize={onAuthorize}
                          onReject={onReject}
                          loading={loading}
                          setLoading={setLoading}
                        />
                      );
                    })}
                  </tbody>
                </Table>
              </Row>
            )}
          </Container>
        </Col>
      </Row>
      <Row>
        <Warning text={texts.notes.authorizations_note} />
      </Row>
    </Fragment>
  );
};
